import React, {useEffect, useState} from "react";
import {useFrame} from "react-frame-component";
import {useMount} from "react-use";

const PixieEditor = (props) => {
    const { document, window: pixieWindow } = useFrame();

    const [source, setSource] = useState(() => props.source);
    const [editor, setEditor] = useState(null);
    /**
     * Called when image is saved via save button, export panel or pixie API.
     */
    const onSave = (data, name) => {
        console.log("onSave", {data, name})
        let canvas = document.createElement('canvas');

        let image = new Image();
        image.onload = function() {
            // const ctx = canvas.getContext("2d");
            // canvas.width = image.width;
            // canvas.height = image.height;
            //
            // ctx.drawImage(
            //     image, 0,0
            // );
            const canvas = document.createElement("canvas");
            const scaleX = image.naturalWidth / image.width;
            const scaleY = image.naturalHeight / image.height;
            let originWidth = image.width * scaleX;
            let originHeight = image.height * scaleY;
            // maximum width/height
            let maxWidth = (props.maxWidth || 2048), maxHeight = 2048 / (props.ratio === '16:9' ? 1.8 : 1)
            let targetWidth = originWidth,
                targetHeight = originHeight;

            if (originWidth > maxWidth || originHeight > maxHeight) {
                if (originWidth / originHeight > maxWidth / maxHeight) {
                    targetWidth = maxWidth;
                    targetHeight = Math.round(maxWidth * (originHeight / originWidth));
                } else {
                    targetHeight = maxHeight;
                    targetWidth = Math.round(maxHeight * (originWidth / originHeight));
                }
            }
            console.log('onload', {originWidth,originHeight,maxWidth,maxHeight,targetHeight,targetWidth})
            // set canvas size
            canvas.width = targetWidth;
            canvas.height = targetHeight;
            const ctx = canvas.getContext("2d");

            ctx.drawImage(
                image,
                0,
                0,
                image.width * scaleX,
                image.height * scaleY,
                0,
                0,
                targetWidth,
                targetHeight
            );
            canvas.toBlob(async(blob) => {
                if (!blob) {
                    //reject(new Error('Canvas is empty'));
                    console.error('Canvas is empty');
                    return;
                }
                let file = new File([blob], name);
                // blob.name = name;

                let fileUrl = window.URL.createObjectURL(blob);
                pixieWindow.pixie.close();
                await TB.wait(400)
                props.onSave(
                    fileUrl,
                    file
                )
            }, 'image/png');
        };
        image.src = data;



    }
    /**
     * Called when pixie editor is fully loaded.
     */
    let onLoad = async (instance) => {
        // await setEditor(instance)
        window.pixieWindow = pixieWindow;
        window.pixieInstance = instance;
        // console.log('onLoad', {
        //     pixieWindow: window.pixieWindow,
        //     pixieInstance: window.pixieInstance
        // })
        // console.log("onLoad", instance)

        // await TB.wait(1000);

        // console.log('onLoad', props.ratio)
        // await instance?.tools?.resize.apply({width: props.width, maintainAspect: true});
        // await TB.wait(200)
        if (props.ratio === '1:1') {
            const width = pixieWindow.pixie.fabric.width;
            const height = pixieWindow.pixie.fabric.height;
            /*Experimental fix for cropping user images*/
            const size = Math.min(width, height);
            const top = (height - size) / 2;
            const left = (width - size) / 2;
            instance.tools?.crop.drawZone({top, left, width: size, height: size})

            // instance.tools?.crop.drawZone({top: 10, left:10, width: width - 20, height: height - 20})
        }
        // pixieWindow.pixie?.tools.corners.apply(200);

    }
    /**
     * Called when editor is closed (via pixie API or close button click)
     */
    const onClose = (...args) => {
        console.log("onClose", args)
        props.onClose()
    }
    /**
     * Called when editor is opened (via pixie API or custom open button)
     */
    const onOpen = (...args) => {
        console.log("onOpen", args)
    }
    /**
     * Called whenever a new file (image or state) is opened via file picker.
     */
    const onFileOpen = (...args) => {
        console.log("onFileOpen", args)
    }
    /**
     * Called when main image is loaded (or changed) in the editor.
     */
    const onMainImageLoaded = (...args) => {
        console.log("onMainImageLoaded", args)


    }

    const setupPixie = (imageSource) => {
        let availableTools = ['crop', 'resize']
        let config = {...pixieWindow.Pixie.defaultConfig};
        if (config) {
            config.ui.nav.items = TB.filter(config.ui.nav.items, tool => {
                return availableTools.includes(tool?.name)
            })
            config.ui.nav.items.push({
                name: 'Replace',
                action: editor => {
                    editor.tools.import.uploadAndReplaceMainImage();
                },
                icon: [
                    {
                        tag: 'path',
                        attr: {
                            d: 'M18 20H4V6h9V4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2v9zm-7.79-3.17-1.96-2.36L5.5 18h11l-3.54-4.71zM20 4V1h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V6h3V4h-3z',
                        },
                    },
                ]
            })
            config.ui.nav.replaceDefault = true;
        }

        let menuBarItems = TB.map([...config.ui.menubar.items], item => {
            if (item.label) {
                item.label = "Done";
                item.icon = null;
            }
            return item;
        });
        pixieWindow.pixie = new pixieWindow.Pixie({
            crossOrigin: true,
            selector: "#container",
            baseUrl: "/static/pixie/assets",
            image: imageSource,
            onSave,
            onLoad,
            onClose,
            onOpen,
            onFileOpen,
            onMainImageLoaded,
            tools: {
                crop: {
                    defaultRatio: props.ratio,
                    allowCustomRatio: false,
                    replaceDefaultPresets: true,
                    presets: [],
                    cropzone: {hideRotatingPoint: true}
                },
                resize:{
                    /**
                     * Minimum width user should be able to resize image to.
                     */
                    // minWidth: 400,
                    //
                    // /**
                    //  * Maximum width user should be able to resize image to.
                    //  */
                    // maxWidth: 800,
                    //
                    // /**
                    //  * Minimum height user should be able to resize image to.
                    //  */
                    // minHeight: 400,
                    //
                    // /**
                    //  * Maximum height user should be able to resize image to.
                    //  */
                    // maxHeight: 800,
                }
            },

            ui: {
                nav: {...config.ui.nav},
                mode: 'overlay',
                defaultTool: 'crop',
                menubar: {
                    replaceDefaultItems: true,
                    items: [
                        {
                            type: 'button',
                            icon: [
                                {
                                    tag: 'path',
                                    attr: {
                                        d: 'M18 20H4V6h9V4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2v9zm-7.79-3.17-1.96-2.36L5.5 18h11l-3.54-4.71zM20 4V1h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V6h3V4h-3z',
                                    },
                                },
                            ],
                            align: 'left',
                            buttonVariant: 'outline',
                            action: editor => {
                                editor.tools.import.uploadAndReplaceMainImage();
                            },
                        },
                        ...menuBarItems
                    ]
                }
            },
        })
        // console.log('navtools', navTools)
        return setEditor(pixieWindow.pixie)
    }
    useMount(() => {
        if (pixieWindow.Pixie) {
            if (props.ratio === '1:1') {
                const image = new Image();
                image.src = source;
                image.onerror = () => {
                    setupPixie(source)
                }
                image.onload = () => {
                    // let canvas = document.createElement('canvas');
                    // let size = TB.max([image.width,image.height]) + 60;
                    //
                    // let x = (image.width < size) ? ((size - image.width) / 2) : 0;
                    // let y = (image.height < size) ? ((size - image.height) / 2) : 0;
                    //
                    // canvas.height = size;
                    // canvas.width = size;
                    //
                    // canvas.getContext('2d').drawImage(image, x, y);
                    // const pixieSource = canvas.toDataURL();
                    // setupPixie(pixieSource)

                    /* EXPERIMENTAL FIX for cropping user images */
                    let canvas = document.createElement('canvas');
                    let size = TB.min([image.width,image.height]);

                    let x = (image.width < size) ? ((size - image.width) / 2) : 0;
                    let y = (image.height < size) ? ((size - image.height) / 2) : 0;

                    canvas.height = image.height;
                    canvas.width = image.width;

                    canvas.getContext('2d').drawImage(image, x, y);
                    const pixieSource = canvas.toDataURL();
                    setupPixie(pixieSource)
                };
            }else {
                setupPixie(source)
            }
        }
    });

    useEffect(() => {
        // console.log('editor', editor)
        if (editor) {

            console.log('state.original', editor.tools.filter);
            let availableTools = ['crop', 'resize']
            // editor?.tools.resize.apply({width: 400, maintainAspect: true})
            // editor?.tools.corners.apply(200);
            // editor.resetEditor(config)

            // let navTools = TB.filter(editor.defaultConfig?.ui?.nav?.items, tool => {
            //     return availableTools.includes(tool?.name)
            // })

            // editor.state.setConfig()
            // editor.tools.filter.apply(editor.tools.filter.getByName('grayscale'));

            // editor?.tools.resize.apply({width: 800,height: 400, maintainAspect: true});
        }
    }, [editor]);

    return <div id="container" />;
}
export default PixieEditor;